// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest,postRequestX,postRequestDownload } from '@/libs/axios';

//database 过滤选项列表
export const getDatabaseFilterList = (params) => {
  return postRequest('/dataset/value', params);
}

//database数据列表
export const getDatabaseDataList = (params) => {
  return postRequest(`/dataset/search`, params);
}

//读取文件接口 relative
export const queryFileDataList = (params) => {
  return postRequestX('/file/readLocalFile', params);
}

//读取文件接口分页
export const queryFilePageDataList = (params) => {
  return postRequestX('/file/readLocalFile/pagination', params);
}

//新的查询分页接口
export const queryFilePageDataListSearch = (params) => {
  return postRequestX('/file/readLocalFile/search/pagination', params);
}


//自动补全接口
export const getAutoSearchGeneList = (id,params) => {
  return postRequest(`/gene/filter/${id}`, params);
}

//查询数据集基本信息
export const querySingleDatasetMessage = (id, params) => {
  return postRequest(`/dataset/info/${id}`, params);
}

//下载数据文件
export const downloadFileInterface = (params) => {
  return postRequestDownload('/file/downloadLocalFile', params);
}

//notice list
export const getNoticeDataList = (params) => {
  return getRequest('/message/invite/info', params);
}

export const countNumberInterface = (params) => {
  return postRequest(`/static/data`, params);
}

//filter caculate
export const queryCaculateList = (params) => {
  return postRequest('/dataset/caculate', params);
}

//pathway caculate
export const queryCaculatePathwayListHTML = (params) => {
  return postRequest('/dataset/caculate/pathwayheatmap/html', params);
}
//pathway caculate
export const queryCaculatePathwayList = (params) => {
  return postRequest('/dataset/caculate/pathwayheatmap', params);
}
export const queryCaculateViolinList = (params) => {
  return postRequest('/dataset/caculate/violinPvalue', params);
}



//gene expression caculate
export const queryGeneExpList = (params) => {
  return postRequest('/dataset/caculate/geneExpCorrelation', params);
}

//LRDotPlot caculate
export const queryLRDotList = (params) => {
  return postRequest('/dataset/caculate/LRPair', params);
}

//LRDotExpressionPlot caculate
export const queryLRExpressionDotList = (params) => {
  return postRequest('/dataset/caculate/LRGeneExp', params);
}

export const queryNetworkPlot= (params) => {
  return postRequest('/dataset/caculate/igraph_plot_network', params);
}

export const queryImage= (params) => {
  return postRequestBlob('/file/image', params);
}

export const queryCalculateCorrelationCutoff = (params) => {
  return postRequest('/dataset/caculate/correlation/cutoff', params);
}

export const queryCalculateCorrelationCutoffImmune = (params) => {
  return postRequest('/dataset/caculate/correlation/cutoff/immune', params);
}
export const queryCalculateCorrelationCutoffAll = (params) => {
  return postRequest('/dataset/caculate/correlation/cutoff/All', params);
}

//控制显示哪些模块
export const queryModel = (id, params) => {
  return postRequest(`/model/data/${id}`, params);
}



// WEBPACK FOOTER //
// ./src/api/index.js